import React from 'react';

import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';

import CheckboxedSection from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/CheckboxedSection';
import { createOptions as incidentCreateEventOptions } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/IncidentEventSelect';
import PagerDutyConditionSelector from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/PagerDutyConditionSelector';
import RowLayout3Components from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RowLayout3Components';
import {
  useSelectedIssueTypes,
  useSelectedProjects
} from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RuleFormContext';
import SelectActions from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectActions';
import { useApplicableActions } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectActions/actions';
import SelectWhenHaveOptions from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectWhenHaveOptions';
import AutoscalableInputsArray from 'src/views/components/Form/AutoscalableInputsArray';
import Field from 'src/views/components/Form/Field';
import FieldLabel from 'src/views/components/Form/FieldLabel';

const InfoMessage = () => {
  return (
    <ul>
      <li>Each Jira issue can only create a single PagerDuty incident. These rules will be ignored if an incident is already linked</li>
      <li>If left unchecked, you can still manually create issues from a PagerDuty incident as long as the service is mapped to a project</li>
    </ul>
  );
};

//TODO: show real warnings here
//JIRA: https://pagerduty.atlassian.net/browse/ITS-4965
const WarningOnMandatoryFieldsMapping = () => {
  return null;
};

const fixedActions = [{ label: 'Create issue', id: '__fixed_create_issue', icon: 'jira' }];

const JiraTargetProjectAndType = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  return (
    <div style={{ width: '100%', display: 'flex' }}>
      <div style={{ width: '50%' }} >
        <Field label="Create issue into project">
          <SelectWhenHaveOptions
            useOptions={useSelectedProjects}
            name={`${name}.target_project`}
            value={values.target_project}
            onChange={onChange}
            onBlur={onBlur}
            isClearable
            hasIcons
          />
        </Field>
      </div>
      <div style={{ width: '10px' }}/>
      <div style={{ width: '50%' }}>
        <Field label="Issue type">
          <SelectWhenHaveOptions
            useOptions={useSelectedIssueTypes}
            name={`${name}.target_issue_type`}
            value={values.target_issue_type}
            onChange={onChange}
            onBlur={onBlur}
            isClearable
            hasIcons
          />
        </Field>
      </div>
    </div>
  );
};

const JiraIssueSettings = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  const actions = useApplicableActions({ issueCreateActions: true, incidentUpdateActions: true });

  return (
    <div style={{ width: '100%' }}>
      <JiraTargetProjectAndType
        name={`${name}`}
        values={values}
        touched={touched}
        errors={errors}
        onChange={onChange}
        onBlur={onBlur}
      />
      <Field label="Additional actions on issue create (optional)">
        <SelectActions
          fixedActions={fixedActions}
          actions={actions}
          name={name}
          values={values}
          touched={touched}
          errors={errors}
          onChange={onChange}
          onBlur={onBlur}
        />
      </Field>
      <WarningOnMandatoryFieldsMapping/>
    </div>
  );
};

const SingleCreationRule = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  return (
    <RowLayout3Components>
      <div>
        <FieldLabel>Create issue when incident: </FieldLabel>
        <PagerDutyConditionSelector
          name={`${name}.condition`}
          values={values.condition}
          touched={touched.condition}
          errors={errors.condition}
          onChange={onChange}
          onBlur={onBlur}
          incidentEventOptions={incidentCreateEventOptions}
        />
      </div>
      <div style={{ paddingTop: 18 }}>
        <ArrowRightIcon size="xlarge"/>
      </div>
      <JiraIssueSettings
        name={`${name}`}
        values={values}
        touched={touched}
        errors={errors}
        onChange={onChange}
        onBlur={onBlur}
      />
    </RowLayout3Components>
  );
};

const newItemValue = {
  condition: {
    pd_events: [],
    pd_urgency: null,
    pd_priorities: [],
  },
  target_project: null,
  target_issue_type: null,
  actions: [],
};

const isItemEmpty = (value) => {
  const { condition, target_project, target_issue_type, actions } = value || {};
  const { pd_events, pd_urgency, pd_priorities } = condition;
  if (Array.isArray(pd_events) && pd_events.length) return false;
  if (Array.isArray(pd_priorities) && pd_priorities.length) return false;
  if (Array.isArray(actions) && actions.length) return false;
  return (!pd_urgency && !target_project && !target_issue_type);
};

const CreateIssue = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  return (
    <div>
      <CheckboxedSection
        name={`${name}.autocreate_issues`}
        value={values.autocreate_issues}
        onChange={onChange}
        onBlur={onBlur}
        label="Сreate Jira issues from PagerDuty incidents"
        helpMessage={<InfoMessage/>}
      >
        <AutoscalableInputsArray
          name={`${name}.autocreate_issues_config`}
          values={values.autocreate_issues_config}
          touched={touched.autocreate_issues_config}
          errors={errors.autocreate_issues_config}
          onChange={onChange}
          onBlur={onBlur}
          ItemComponent={SingleCreationRule}
          isItemEmpty={isItemEmpty}
          newItemValue={newItemValue}
        />
        <div style={{ height: '50px' }}/>
      </CheckboxedSection>
    </div>
  );
};

export default CreateIssue;
